<template>
    <div class="body-panel dataContent">
        <template v-if="material != null">
            <div class="body-panel-control separator">
                <div class="control-block-left">
                    <div class="flex">
                        <p class="btn-back">
                            <a class="router-link-active" @click.stop="onBack()">
                                <template v-if="activeTab === 'test'">
                                    Назад к материалу
                                </template>
                                <template v-else>
                                    Назад
                                </template>
                            </a>
                        </p>
                    </div>
                </div>
                <div class="control-block-right flex btns" v-if="info.User && (hasClaims(info.User.DynamicRole, claimEnums.materialCreate) || info.User.MainRole === 'administrators')">
                    <button type="button" class="btn" v-if="info.User.MainRole === 'administrators'" @click="onExportMaterial()">Экспорт</button>
                    <button type="button" class="btn" @click="onEditMaterial()">Редактировать</button>
                </div>
            </div>
            <div class="body-panel-content body-panel-content-page" id="playerContainer">
                <div class="mob-flex-to-block height-full mob-height-auto material-conteiner">
                    <div class="material-body" :style="{display: activeTab === 'info' ? 'block' : 'none'}">

                        <div class="material-body-content flex course-content">
                            <div class="course-info">
                                <h2>{{ material.Name }}</h2>
                                <div v-html="material.Description"></div>

                                <div class="panel-body-stats" v-if="material.LikesEnabled || material.DisplayViews">
                                    <p @click.stop="onMakeMark" title="Нравится" :class="['news-actions like', {'bold': material.MyVote === true}]" v-if="material.LikesEnabled">
                                        <svg class="svg-icon like-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Like"></use>
                                        </svg>
                                        <svg class="svg-icon like-2" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Like2"></use>
                                        </svg>
                                        <span>{{material.LikesCount}}</span>
                                    </p>

                                    <p class="news-actions margin-left-15" v-if="material.DisplayViews" @click.stop="onShowUsers">
                                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg"
                                             xmlns:xlink="http://www.w3.org/1999/xlink">
                                            <use xlink:href="/Content/dist/image_svg.svg#Eye"></use>
                                        </svg>
                                        <span>{{material.ViewsCount}}</span>
                                    </p>
                                </div>
                            </div>
                            <div class="course-material-files">
                                <ul v-if="material.CertificateSettings && material.CertificateSettings.Issuance !== 'undefined' && material.CertificateSettings.Issuance.Actived">
                                    <li>
                                        <span class="head">Сертификат за прохождение курса</span>
                                        <div class="flex">
                                            <div>
                                                <div>
                                                    <span v-if="!material.TestComplete" style="padding-top:7px">
                                                        {{material.CertificateSettings.Issuance.data.front}}
                                                    </span>
                                                    <span v-if="results && material.TestComplete && !material.CertificateSessionId" style="padding-top:7px">
                                                        {{material.CertificateSettings.Issuance.data.before}}
                                                    </span>
                                                    <span v-if="results && material.TestComplete && material.CertificateSessionId" style="padding-top:7px">
                                                        {{material.CertificateSettings.Issuance.data.after}}
                                                    </span>
                                                </div>
                                                <div class="margin-top-20" v-if="results && material.TestComplete && material.CertificateSessionId">
                                                    <button type="button" class="btn" @click="onCertificateDownload(material.CertificateSessionId)">Скачать</button>
                                                </div>
                                            </div>
                                            <div class="material-sert-icon">
                                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                                    <use xlink:href="/Content/dist/image_svg.svg#Sert"></use>
                                                </svg>
                                            </div>
                                        </div>
                                    </li>
                                </ul>
                                <h2>Материалы</h2>
                                <ul>
                                    <li v-for="materialFile in material.Files">
                                        <span class="head">{{materialFile.Name}}</span>
                                        <div class="flex">
                                            <span v-if="materialFile.Available" style="padding-top:7px">{{materialFile.ProgressStatus}}</span>
                                            <span v-if="!materialFile.Available" style="color:#728a9a;padding-top:7px">Изучите предыдущий материал</span>
                                            <div style="margin-left: auto; display: flex; align-items: center;">
                                                <svg style="margin-right:7px;" class="svg-icon" xmlns="http://www.w3.org/2000/svg"
                                                     xmlns:xlink="http://www.w3.org/1999/xlink" v-if="!materialFile.Available">
                                                    <use xlink:href="/Content/dist/image_svg.svg#Lock"></use>
                                                </svg>
                                                <button type="button" class="btn btn-primary" @click="onViewMaterialFile(materialFile)" :disabled="!materialFile.Available">
                                                    <template v-if="materialFile.ProgressPercent == null">
                                                        Начать изучение
                                                    </template>
                                                    <template v-if="materialFile.ProgressPercent == 1">
                                                        Изучить еще раз
                                                    </template>
                                                    <template v-if="materialFile.ProgressPercent != null && materialFile.ProgressPercent < 1">
                                                        Продолжить изучение
                                                    </template>
                                                </button>
                                            </div>
                                        </div>
                                    </li>

                                </ul>
                                <h2 v-if="TesCanBeShown" class="margin-top-15">{{ material.TestTabName || 'Тестирование' }}</h2>
                                <ul v-if="TesCanBeShown">
                                    <li>
                                        <div class="flex">
                                            <span v-if="results && material.TestComplete" class="green-text" style="padding-top:7px">
                                                Тест успешно сдан
                                            </span>
                                            <span v-if="results && !material.TestComplete" class="red-text" style="padding-top:7px">
                                                Вы не сдали тест
                                            </span>
                                            <span v-if="!TestAvailable && results === null" style="color:#728a9a;padding-top:7px">
                                                Изучите материалы для сдачи теста
                                            </span>
                                            <span v-if="TestAvailable && results === null" class="green-text" style="padding-top:7px">
                                                Пройдите тест!
                                            </span>

                                            <div style="margin-left: auto; display: flex; align-items: center;">
                                                <svg style="margin-right:7px;" class="svg-icon" xmlns="http://www.w3.org/2000/svg"
                                                     xmlns:xlink="http://www.w3.org/1999/xlink" v-if="!TestAvailable">
                                                    <use xlink:href="/Content/dist/image_svg.svg#Lock"></use>
                                                </svg>
                                                <button type="button" class="btn margin-right-20"
                                                        v-if="results != null"
                                                        @click.stop="$refs['ppTestResults'].show()">
                                                    Результат попытки
                                                </button>
                                                <button type="button" class="btn btn-primary"
                                                        :disabled="!TestAvailable || timeLeft != null || material.AttemptsLeft === 0" v-if="!material.TestComplete"
                                                        @click="onTestTabClick()" :title="TestAvailable ? '' : 'Пройдите все обучающие материалы. После этого тест станет доступен'">
                                                    Сдать тест
                                                </button>

                                            </div>
                                        </div>
                                        <p class="margin-top-10" style="color:#728a9a;" v-if="timeLeft">
                                            Следующая попытка через {{timeLeft}}
                                        </p>
                                        <p class="margin-top-10" style="color:#728a9a;" v-if="material.AttemptsLeft === 0">
                                            Все попытки израсходованы
                                        </p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="material-body" :style="{display: activeTab === 'test' ? 'block' : 'none'}" v-if="!material.TestDisabled && TestAvailable">
                        <div class="material-body-content flex course-content">
                            <div class="course-info">
                                <h2>{{ material.Name }}</h2>
                                <div v-html="material.TestGreeting"></div>

                                <p v-if="material.AttemptsLeft === 0">
                                    Кол-во попыток прохождения теста израсходовано
                                </p>
                                <button type="button" class="btn margin-top-20" v-if="testBtnShow" @click.stop="onMaterialTest()">
                                    Пройти тест
                                </button>
                            </div>
                            <div class="course-material-files">
                                <ul>
                                    <li>
                                        <span class="head">Время теста</span>
                                        <div class="flex">
                                            <span>{{ material.TestTime ? material.TestTime : 'Не ограничено'}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="head">Номер попытки</span>
                                        <div class="flex">
                                            <span>#{{material.Attempt}} {{ material.TestAttemptsNumber ? ` из ${material.TestAttemptsNumber}` : '' }}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <span class="head">Всего вопросов</span>
                                        <div class="flex">
                                            <span>{{ material.QuestionsToAsk ? material.QuestionsToAsk : material.Questions.length}}</span>
                                        </div>
                                    </li>
                                    <li v-if="material.Bonus">
                                        <span class="head">Итого баллов</span>
                                        <div class="flex">
                                            <span>{{(material.Bonus||0)}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </template>

        <popup-window ref="ppUsers" :title="'Пользователи, просмотревшие материал'" :width="800" @onBottomScrolled="onBottomScrolledUsers">
            <button class="btn" type="button" @click="onExport()" style="margin: 0 0 10px auto;">Экспорт</button>
            <table class="t-data" style="max-width:1000px;margin:0 auto">
                <thead>
                <tr class="heading">
                    <th class="with-img mob-hide">Пользователь</th>
                    <th class="w150-r">Дата просмотра</th>
                    <th class="w150-r">Дата лайка</th>
                    <th class="w150-r">Дата последней попытки</th>
                    <th class="w150-r">Результат </th>
                </tr>
                </thead>
                <tbody>
                <template v-for="item of users.data">
                    <tr :class="['hide-when-not-mob']">
                        <td class="number">
                            <img v-if="item.UserImage !== null" :src="'/uploads/users/' + item.UserImage" />
                            <img v-else src="../../../img/u57.png" />
                        </td>
                        <td class="with-img">
                            <span>{{ item.UserFio }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td class="with-img mob-hide">
                            <img v-if="item.UserImage !== null" :src="'/uploads/users/' + item.UserImage" />
                            <img v-else src="../../../img/u57.png" />
                            <span>{{ item.UserFio }}</span>
                        </td>
                        <td class="w150-r" style="text-align:center">{{ formatDateLong(item.ViewedDate) }}</td>
                        <td class="w150-r" style="text-align:center">{{ formatDateLong(item.LikedDate) }}</td>
                        <td class="w150-r" style="text-align:center">{{ formatDateLong(item.LastAttemptDate) }}</td>
                        <td class="w150-r" style="text-align:center">
                            <span v-if="item.LastAttemptDate">
                                {{ item.LastAttemptComplete ? 'Сдал' : 'Не сдал' }}
                            </span>
                        </td>
                    </tr>
                </template>
                </tbody>
            </table>
        </popup-window>

        <popup-window ref="ppTestResults" :title="'Результаты последней попытки'" :width="'800px'" :height="'95%'" @onClose="onTestResultsClosed">
            <div>
                <div v-if="results != null && material != null">
                    <div class="test-result-body">
                        <div class="test-result-body-header flex">
                            <div class="test-result-body-icon">
                                <svg class="svg-icon" v-if="results.Complete" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#ResultOk"></use>
                                </svg>
                                <svg class="svg-icon err" v-if="!results.Complete" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#ResultErr"></use>
                                </svg>
                            </div>
                            <div class="test-result-body-text">
                                <p class="caption-help">Тест завершён!</p>
                                <p class="test-hello-text" v-if="!results.Complete">Вы не сдали тест</p>
                                <p class="test-hello-text" v-if="results.Complete">Вы сдали тест</p>
                            </div>
                        </div>

                        <div class="test-stats-row flex">
                            <div class="test-stats-cell">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#Time"></use>
                                </svg>
                                <p class="margin-top-10 caption-help">Время теста</p>
                                <p class="margin-top-5 p-header-1">
                                    {{ results.TestTime || '00:00:00 ' }}
                                    / {{ results.MaterialTestTime ? results.MaterialTestTime : '&infin;'}}
                                </p>
                            </div>
                            <div class="test-stats-cell">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#Hash"></use>
                                </svg>
                                <p class="margin-top-10 caption-help">Номер попытки</p>
                                <p class="margin-top-5 p-header-1">
                                    {{ results.Attempt }}
                                    <template v-if="results.MaterialAttempts">
                                        / {{results.MaterialAttempts}}
                                    </template>
                                </p>
                            </div>
                            <div class="test-stats-cell">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#Check"></use>
                                </svg>
                                <p class="margin-top-10 caption-help">Статистика ответов</p>
                                <p class="margin-top-5 p-header-1"><span>{{ results.QuestionsRight }} ({{results.QuestionsRightPercent}}%)</span> / {{ results.MaterialQuestions }}</p>
                            </div>
                            <div class="test-stats-cell" v-if="material.Bonus > 0 || results.BonusMessage != null">
                                <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                                    <use xlink:href="/Content/dist/image_svg.svg#Star"></use>
                                </svg>
                                <p class="margin-top-10 caption-help">Итого баллов</p>
                                <p class="margin-top-5 p-header-1">
                                    {{ results.BonusMessage == null ? (results.Bonus||0) : results.BonusMessage }}
                                    <template v-if="results.MaterialBonus">
                                        / {{results.MaterialBonus}}
                                    </template>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div v-if="results != null && material != null && material.TestDisplayStats && results.Answers.length > 0">
                    <div style="font-weight:600" class="margin-top-15 margin-bottom-10">Ваши ответы</div>
                    <table v-if="!isMobile" class="table-view">
                        <thead>
                        <tr class="heading">
                            <th>#</th>
                            <th align="left">Вопрос</th>
                            <th>Результат</th>
                            <th>Время ответа</th>
                            <th>Баланс</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item, i) of results.Answers">
                            <td align="center">{{i + 1}}</td>
                            <td>{{item.QuestionDescription}}</td>
                            <td align="center" :class="['qwestion-result', {'err': !item.Correct }]">{{item.Correct ? 'Верно': 'Не верно'}}</td>
                            <td align="center">{{item.AnswerTime}}</td>
                            <td align="center">{{item.Balance ? item.Balance.toFixed(0) : null }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div v-if="isMobile" class="table-div" v-for="(item, i) of results.Answers">
                        <div class="flex caption-help">
                            <div style="width:50%">Вопрос</div>
                            <div style="width:50%;text-align:right"># {{i+1}}</div>
                        </div>
                        <div class="margin-top-5" style="font-size:14px;font-weight:600">
                            {{item.QuestionDescription}}
                        </div>
                        <div class="flex margin-top-5">
                            <div style="width:50%">Результат</div>
                            <div style="width:50%;text-align:right" :class="['qwestion-result', {'err': !item.Correct }]">{{item.Correct ? 'Верно': 'Не верно'}}</div>
                        </div>
                        <div class="flex margin-top-2">
                            <div style="width:50%">Время ответа</div>
                            <div style="width:50%;text-align:right">{{item.AnswerTime}}</div>
                        </div>
                        <div class="flex margin-top-2" v-if="item.Balance">
                            <div style="width:50%">Баллы</div>
                            <div style="width:50%;text-align:right">{{item.Balance.toFixed(0)}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </popup-window>

        <vue-headful title="Материалы" />
    </div>
</template>


<script>
    import BackendApi from '../../backendApi'
    import UI from '../../helpers/ui-helpers'
    import config from '../../config'

    let backendApi = new BackendApi();

    let iFrame;

    export default {
        name: "material-details",

        props: ['info'],

        data() {
            return {
                material: null,
                timeLeft: null,
                users: {
                    data: [],
                    page: 1,
                    loading: false,
                    canBeLoaded: true
                },
                activeTab: 'info',
                analyticsType: 'top',
                results: null,
                isMobile: UI.check_mobile(),
                rating: null,
                currentMaterialFile: null
            }
        },

        watch:{
            '$route.params': function(){
                //console.info('this.$route.query.test', this.$route.query)
                this.activeTab = this.$route.query.tab ? 'test' : 'info';
            }
        },

        computed: {
            TestAvailable(){
                return this.material.Files.filter(x => x.ProgressPercent !== 1).length === 0;
            },

            TesCanBeShown(){
                return this.material && !this.material.TestDisabled && this.material.Questions.filter(x => x.Active).length;
            },

            // myPlace(){
            //     if(this.results != null){
            //         let item = this.results.Top10.find(x => x.UserId === this.info.User.Id);
            //         if(item){
            //             return item.Place;
            //         }
            //     }
            //     return 0;
            // },

            testBtnShow() {
                let flag = true;

                //console.info('testBtnShow', [this.material.AllowedAttemptTime, this.material.AttemptsLeft, this.material.TestComplete]);

                if (this.material.AllowedAttemptTime != null || this.material.AttemptsLeft === 0 || this.material.TestComplete) {
                    flag = false;
                }

                return flag;
            },

            // testResultsDescription(){
            //     let obj = {
            //         percent: null,
            //         statusName: 'Не начат',
            //         btnText: this.material.TestButtonName || 'Пройти тест'
            //     };
            //     if(this.results == null){
            //         return obj;
            //     }else{
            //         if(!this.results.Complete){
            //             obj.btnText = 'Повторить попытку';
            //             obj.statusName = 'Тест не сдан';
            //         }
            //         else{
            //             obj.btnText = null;
            //             obj.statusName = 'Тест сдан';
            //         }
            //         obj.percent = this.results.QuestionsRightPercent;
            //
            //         return obj;
            //     }
            // },
            //
            // MeterialProgressPercent() {
            //     let sum = 0;
            //     for (let file of this.material.Files) {
            //         sum += (file.ProgressPercent ? file.ProgressPercent : 0);
            //     }
            //     return sum / this.material.Files.length;
            // }
        },

        methods: {
            onTestResultsClosed(){
                // let tab = this.$route.query.tab;
                // if(tab){
                //     if(['results'].indexOf(tab.toLowerCase()) !== -1){
                //         this.$router.push('/materials/' + this.material.Id);
                //     }
                // }
            },
            
            onBack(){
                if(this.activeTab === 'test'){
                    this.$router.push('/materials/' + this.material.Id);
                }
                else{
                    this.$router.push('/materials');
                    //this.$router.back();
                }
            },

            onTestTabClick(){
                if(this.TestAvailable){
                    this.activeTab = 'test';
                    this.$router.push('?tab=test');
                }else{
                    alert('Пройдите все обучающие материалы. После этого тест станет доступен');
                }
            },

            onViewMaterialFile(materialFile) {
                this.$router.push('/materials/' + this.material.Id + '/' + materialFile.Id);

                // this.currentMaterialFile = materialFile;
                // let page = materialFile.ProgressPage;
                // if(page == null){
                //     page = materialFile.ActiveContentType === 3 ? 1 : 0;
                // }
                // this.onContinueViewing(page);
            },

            // onPageChanged(page, duration){
            //     //console.info('onPageChanged:', page);
            //     this.updateProgress(page, duration);
            // },
            //
            // updateProgress(page, duration){
            //     let vm = this;
            //     if(vm.currentMaterialFile == null)
            //     {
            //         console.info('currentMaterialFile is null');
            //         return;
            //     }
            //     this.callApiWrapper(backendApi.materialUpdateProgress(vm.currentMaterialFile.Id, page, duration))
            //         .then(function (resp) {
            //             if (!resp.hasError) {
            //                 if(resp.data.ProgressPercent === 1){
            //                     vm.currentMaterialFile.ProgressStatus = 'Завершён';
            //                 }
            //                 else{
            //                     vm.currentMaterialFile.ProgressStatus = `Изучено ${(resp.data.ProgressPercent*100).toFixed(0)}%`;
            //                 }
            //                 vm.currentMaterialFile.ProgressPage = resp.data.ProgressPage;
            //                 vm.currentMaterialFile.ProgressPercent = resp.data.ProgressPercent;
            //
            //                 if(resp.data.ProgressPercent === 1) {
            //                     for (let i = 0; i < vm.material.Files.length; i++) {
            //                         if (!vm.material.FilesOrderLocked || i === 0 || vm.material.Files[i - 1].ProgressPercent == 1) {
            //                             vm.material.Files[i].Available = true;
            //                         }
            //                     }
            //                 }
            //             }
            //         });
            // },
            //
            // onContinueViewing(page) {
            //     let materialFile = this.currentMaterialFile;
            //     if (materialFile.ActiveContentType === 4) {
            //
            //         this.$refs['videoView'].show('https://storage.yandexcloud.net/' + config.yandexCloudBucketName + '/' + materialFile.ContentFileName, page);
            //
            //     } else if (materialFile.ActiveContentType === 3) {
            //         this.$refs['pdfView'].show('https://storage.yandexcloud.net/' + config.yandexCloudBucketName + '/' + materialFile.ContentFileName, page);
            //     } else if(materialFile.ActiveContentType === 2){
            //         this.$refs['videoView'].show(materialFile.ContentFileName, page, true);
            //     }
            //     else if(materialFile.ActiveContentType === 1){
            //         this.$refs['presentationView'].show(config.apiUrl + '/Home/Player?materialId=' + this.material.Id + '&page=' + page);
            //     }
            //     else if(materialFile.ActiveContentType === 5){
            //         this.$refs['scormView'].show(`/uploads/materials/${this.material.ProjectId}/${this.material.Id}/${materialFile.Id}/${materialFile.ScormStartPath}`);
            //     }
            // },

            // toggleAnalytics(){
            //     this.analyticsType = this.analyticsType === 'top' ? 'all' : 'top';
            //     if(this.rating == null && this.analyticsType === 'all'){
            //         this.loadMaterialTestRating();
            //     }
            // },

            formatAnswerStats(questionsRight, questionsWrong) {
                let count = questionsRight + questionsWrong;
                let questionsRightPercent = questionsRight * 100 / ( count === 0 ? 1: count);

                return questionsRight + ' (' + questionsRightPercent.toFixed(2) + '%) / ' + count;
            },

            formatTimeLeft(ms) {
                if(ms <= 0){
                    return null;
                }

                let time = new Date(ms);

                let hours = time.getUTCHours();
                let minutes = time.getUTCMinutes();
                let seconds = time.getUTCSeconds();

                let days = Math.floor((ms - hours * 60 * 60 * 1000 - minutes * 60 * 1000 - seconds * 1000) / (24 * 60 * 60 * 1000));

                let formatted = (days > 0 ? days + ' ' + this.get_text_ending(days, ['день','дня','дней']) : '') +
                    (hours > 0 ? ' ' + hours + ' ' + this.get_text_ending(hours, ['час','часа','часов']) : '') +
                    (hours > 0 || minutes > 0 ? ' ' + minutes + ' ' + this.get_text_ending(minutes, ['минуту','минуты','минут']) : '') +
                    (hours > 0 || minutes > 0 || seconds > 0 ? ' ' + seconds + ' ' + this.get_text_ending(seconds, ['секунду','секунды','секунд']) : '')

                return formatted.trim();
            },

            getImageStyleFormatted(imageStyle){

                if(!imageStyle){
                    return null;
                }

                let settings = {
                    left: imageStyle.left + '%',
                    top: imageStyle.top + '%',
                    transform: 'translateY(' + imageStyle.translateY + '%) translateX(' +
                    imageStyle.translateX + '%)'
                };
                if(imageStyle.resizeType === 1 && parseInt(imageStyle.size)){
                    settings.height = imageStyle.size + '%';
                }
                if(imageStyle.resizeType === 2 && parseInt(imageStyle.size)){
                    settings.width = imageStyle.size + '%';
                }

                return settings;
            },

            onMakeMark() {
                let vm = this;
                backendApi.materialMakeVote(this.material.Id).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при выполнении запроса. Попробуйте позже');
                    } else {
                        vm.material.MyVote = !vm.material.MyVote;
                        vm.material.LikesCount = response.data.LikesCount;
                    }
                });
            },

            onEditMaterial() {
                this.$router.push('/materials/edit/' + this.material.Id);
            },

            onExportMaterial() {
                let vm = this;

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.materialResultsExportUsers(vm.material.Id))
                    .then(function (resp) {
                        console.info('export', resp, vm.material);
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, vm.material.Name + '.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            } else {
                                UI.toastr.error('Пустой материал');
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            onMaterialTest() {
                this.$router.push('/materials/' + this.material.Id + '/test?start');
            },

            // onMaterialTest53() {
            //     this.$router.push('/materials/' + this.material.Id + '/okko');
            // },
            //
            // onMaterialTestResults() {
            //     this.$router.push('/materials/' + this.material.Id + '/testresults');
            // },

            onShowUsers() {
                if (this.info.User.MainRole !== 'administrators')
                    return;

                this.$nextTick(() => {

                    this.users.data = [];
                    this.users.page = 1;
                    this.users.canBeLoaded = true;
                    this.users.loading = false;
                    this.loadNextUsers();
                    this.$refs['ppUsers'].show();
                });
            },

            loadNextUsers() {
                let vm = this;

                vm.users.loading = true;
                UI.blockUI('.popup', 'Загрузка...');
                this.callApiWrapper(backendApi.materialUsersList((this.users.page - 1) * 20, 20, this.material.Id))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время загрузки лайков');
                        }
                        else {
                            if (resp.data && resp.data.length) {
                                vm.users.data.push(...resp.data);
                            }
                            else {
                                vm.users.canBeLoaded = false;
                            }
                        }
                        UI.unblockUI('.popup');
                        vm.users.loading = false;
                    })
            },

            onExport(){
                let vm = this;

                UI.blockUI('#app');
                vm.callApiWrapper(backendApi.materialExportUsers(vm.material.Id))
                    .then(function (resp) {
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время экспорта');
                        }
                        else {
                            let exportFile = resp.data;
                            if (exportFile != null) {
                                UI.downloadFileByBytes(exportFile, 'Пользователи, просмотревшие материал.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                            }
                        }
                        UI.unblockUI('#app');
                    });
            },

            onBottomScrolledUsers() {
                let vm = this;

                if (!vm.users.loading && vm.users.canBeLoaded) {
                    vm.users.page++;
                    vm.loadNextUsers();
                }
            },

            loadMaterial() {
                let vm = this;
                let id = parseInt(this.$route.params.id);
                return this.callApiWrapper(backendApi.materialLoad(id)).then(function (response) {
                    if (response.hasError) {
                        UI.toastr.error('Ошибка при загрузке материала');
                    }
                    else {
                        if (response.data == null) {
                            vm.$router.push('/materials');
                        }
                        else {
                            vm.material = response.data;

                            if (vm.material.AllowedAttemptTime) {
                                let allowedAttemptTime = new Date(vm.material.AllowedAttemptTime);
                                vm.timeLeft = vm.formatTimeLeft(allowedAttemptTime - new Date());

                                let interval = window.setInterval(function runImmediately() {
                                    let ms = allowedAttemptTime - new Date();
                                    if (ms <= 0) {
                                        vm.timeLeft = null;
                                        vm.material.AllowedAttemptTime = null;
                                        window.clearInterval(interval);
                                    }
                                    else {
                                        vm.timeLeft = vm.formatTimeLeft(ms);
                                    }

                                }, 1000);
                            }

                            if (vm.material.CertificateSettings) {
                                vm.material.CertificateSettings = JSON.parse(vm.material.CertificateSettings);
                            }
                        }
                    }
                })
            },

            loadMaterialTestResults() {
                let vm = this;
                let id = parseInt(this.$route.params.id);

                return this.callApiWrapper(backendApi.materialLoadTestResults(id)).then(function (response) {
                    if (response.hasError) {
                        //UI.toastr.error('Ошибка при загрузке результатов теста');
                    }
                    else {
                        if (response.data != null) {
                            vm.results = response.data.Results;

                            let totalAnswers = vm.results.QuestionsRight + vm.results.QuestionsWrong;
                            vm.results.QuestionsRightPercent = (vm.results.QuestionsRight * 100 / (totalAnswers > 0 ? totalAnswers : 1)).toFixed(2);
                        }
                    }
                });
            },

            // loadMaterialTestRating() {
            //     let vm = this;
            //     let id = parseInt(this.$route.params.id);
            //
            //     return this.callApiWrapper(backendApi.materialLoadTestRating(id)).then(function (response) {
            //         if (response.hasError) {
            //             UI.toastr.error('Ошибка при загрузке рейтинга');
            //         }
            //         else {
            //             if (response.data != null) {
            //                 vm.rating = response.data;
            //             }
            //         }
            //     });
            // }

            onCertificateDownload(sessionId) {
                let vm = this;
                UI.blockUI('dataContent', 'Просмотр сертификата');
                vm.callApiWrapper(backendApi.materialCertificateDownload(sessionId, true))
                    .then(function (resp) {
                        UI.unblockUI('.dataContent');
                        if (resp.hasError && resp.status !== 401) {
                            UI.toastr.error('Ошибка во время скачивания');
                            console.info('error status', resp.status);
                        }
                        else {
                            console.info('resp.data', resp.data, resp);
                            //window.location.href = resp.data;
                            window.open(resp.data, '_blank');
                        }
                    });
            },
        },

        mounted() {
            let vm = this;

            UI.blockUI('.dataContent', 'Загрузка...');
            Promise.all([this.loadMaterial(), this.loadMaterialTestResults()]).then(() => {
                UI.unblockUI('.dataContent');

                vm.$nextTick(() => {

                    if (vm.material.ActiveContentType === 1 && (vm.material.Status === 2 || (vm.info.User.MainRole === 'administrators'))) {

                        let materialId = parseInt(vm.$route.params.id);
                        let playerContainer = document.getElementById('playContent');

                        if (playerContainer != null) {
                            iFrame = document.createElement('iframe');
                            iFrame.src = config.apiUrl + '/Home/Player?materialId=' + materialId;
                            let div = document.createElement('div');
                            div.className = "scroll_frame";
                            div.appendChild(iFrame);
                            playerContainer.appendChild(div);
                        }
                    }

                    let tab = vm.$route.query.tab;
                    if(tab){
                        if(['test'].indexOf(tab.toLowerCase()) !== -1){
                            vm.activeTab = tab.toLowerCase();
                        }

                        if(['results'].indexOf(tab.toLowerCase()) !== -1){
                            vm.$refs['ppTestResults'].show();
                        }
                    }

                });
            });


        },

        destroyed() {
            if (iFrame != null) {
                iFrame.parentNode.removeChild(iFrame);
            }
        }

    }
</script>

<style scoped>
    .panel-body-stats{
        position: initial;
        padding: 0;
    }
    .panel-body-stats p{
        margin-left: 0;
    }
    .panel-body-stats p + p{
        margin-left: 15px;
    }
    .btn:disabled{

    }
</style>


// WEBPACK FOOTER //
// Content/src/views/details/MaterialDetails.vue